import { ChangeDetectorRef, Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AgentFollowFeedService } from './agent-follow-feed.service';
import { DpgfActivityFeed, FeedCardView } from './agent-follow-feed';

// Card « Claude modifie Aglo » of the DPGF activity feed (docs/mcp/06-FRONT.md §8.3): the latest change of Claude, of a
// « Connexion IA » or of a colleague's agent in the DPGF open, with [Voir] for everybody and [Annuler cette modification]
// / [Mettre Claude en pause] for its author only (U17). Mounted by the activity bubble when the agent of the panel shows
// nothing, at the same place and with the bubble's own styles; texts by interpolation only.
@Component({
  selector: 'app-agent-follow-card', standalone: true, imports: [CommonModule],
  templateUrl: './agent-follow-card.component.html', styleUrls: ['./agent-activity-bubble.component.scss']
})
export class AgentFollowCardComponent implements OnInit, OnDestroy {
  @Input() panelOpen = false;
  @Input() mobile = false;
  @Input() raised = false;
  readonly feed: DpgfActivityFeed;
  card: FeedCardView | null = null;
  private ticker: ReturnType<typeof setInterval> | null = null;
  private subscription: Subscription | null = null;
  private key = '';
  private destroyed = false;

  constructor(private service: AgentFollowFeedService, private cd: ChangeDetectorRef, private zone: NgZone) {
    this.feed = service.feed;
  }
  ngOnInit() {
    this.subscription = this.service.viewChanged$.subscribe(() => this.zone.run(() => this.refresh(true)));
    this.refresh(false);
    // « il y a 40 s », end of the card after 2 min: checked every second without app-wide change detection.
    this.zone.runOutsideAngular(() => { this.ticker = setInterval(() => this.refresh(true), 1000); });
  }
  ngOnDestroy() { this.destroyed = true; if (this.ticker) clearInterval(this.ticker); this.subscription?.unsubscribe(); }

  get shown() { return Boolean(this.card) && !(this.mobile && this.panelOpen); }
  private refresh(detect: boolean) {
    if (this.destroyed) return;
    const card = this.feed.cardView();
    const key = JSON.stringify([card, this.feed.message, this.feed.busy]);
    if (key === this.key) return;
    this.key = key; this.card = card;
    if (detect) this.cd.detectChanges();
  }

  view() { void this.feed.view(); }
  undo() { void this.feed.undo(); }
  pause() { void this.feed.pause(); }
  dismiss() { this.feed.dismiss(); }
}
